import { Theme, css } from "@emotion/react"

export const footerStyle = (theme: Theme) => css`
	background: ${theme.palette.primary.dark};
	min-height: 26rem;

	${theme.breakpoints.down("sm")} {
		display: none;
	}

	h2 {
		color: #87cefa;
		font-size: 1rem;
		font-weight: 700;
		margin-bottom: 1rem;
		text-transform: uppercase;

		${theme.breakpoints.down("sm")} {
			margin-top: 2.5rem;
		}
	}

	p,
	a {
		font-size: 1rem;
		font-weight: 500;
		color: #ffffff;
		text-decoration: none;
	}

	a:hover {
		color: #87cefa;
	}

	img {
		margin-bottom: 2rem;
		aspect-ratio: 128 / 40;
	}

	div.innerFooter {
		display: flex;
		flex-direction: row;
		padding: 4rem 2.5rem;

		> * {
			min-width: 20rem;
		}

		${theme.breakpoints.down("sm")} {
			flex-direction: column;
			min-height: 3rem;
		}
	}

	li span {
		margin-right: 0.5rem;
	}

	li {
		margin-bottom: 1rem;

		&:last-child {
			margin-bottom: 0;
		}
	}
`

export const contactContainerStyle = (theme: Theme) => css`
	${theme.breakpoints.down("sm")} {
		margin-left: 0;
	}
`
export const bottomFooterStyleLight = (theme: Theme) => css`
	background-color: white;
	display: flex;
	justify-content: space-between;
	max-width: 100%;

	p,
	a {
		font-size: 14px;
		text-decoration: none;
	}

	p {
		font-weight: 500;
		color: ${theme.palette.colors.gray600};
	}

	${theme.breakpoints.down("sm")} {
		flex-direction: column;
	}

	a:nth-of-type(2) {
		margin-left: 4rem;
	}
`

export const termsStyleLight = (theme: Theme) => css`
	display: flex;
	justify-content: space-between;

	${theme.breakpoints.down("sm")} {
		margin-bottom: 1rem;
	}

	a {
		color: ${theme.palette.colors.gray600};
	}

	a:hover {
		text-decoration: underline;
	}

	a:nth-of-type(2) {
		margin-left: 4rem;
	}
`

export const bottomFooterStyle = (theme: Theme) => css`
	background-color: #00192f;
	padding: 2rem;
	display: flex;
	justify-content: space-between;

	p,
	a {
		font-size: 14px;
	}

	${theme.breakpoints.down("sm")} {
		flex-direction: column;
	}

	a:nth-of-type(2) {
		margin-left: 4rem;
	}
`

export const termsStyle = (theme: Theme) => css`
	display: flex;

	${theme.breakpoints.down("sm")} {
		margin-bottom: 1rem;
	}
`

export const socialMediaList = css`
	a {
		color: #00254a;
	}

	h2 {
		margin-top: 2.5rem;
	}

	ul {
		li {
			display: inline-block;
			margin-bottom: 0;
		}
	}
`

export const socialMediaListMobile = (theme: Theme) => css`
	nav {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		color: ${theme.palette.colors.brandDeepNavy};
		margin-bottom: 3rem;

		h2 {
			font-size: 1rem;
			font-weight: 700;
			text-transform: uppercase;
		}

		ul {
			display: flex;
			flex-direction: row;
			gap: 1rem;
		}
	}
`
